webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(17);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(11);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.config.productionTip = false;
	
	new _vue2.default({
	    el: '#app',
	    template: '<App/>',
	    components: { App: _App2.default }
	});

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ContentBlock = __webpack_require__(12);
	
	var _ContentBlock2 = _interopRequireDefault(_ContentBlock);
	
	var _HeaderBlock = __webpack_require__(13);
	
	var _HeaderBlock2 = _interopRequireDefault(_HeaderBlock);
	
	var _gsap = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'app',
	    components: {
	        ContentBlock: _ContentBlock2.default,
	        HeaderBlock: _HeaderBlock2.default
	    },
	    data: function data() {
	        return {
	            blocks: [{
	                background: 'background-9.jpg',
	                title: 'Your Story',
	                subTitle: 'I BRING IT TO LIVE IN CAMPAIGNS, CONTENT AND ACTIVATION',
	                videoUrl: '278625232',
	                footerTop: 'TO PROTECT WHAT WE VALUE MOST / MINISTRY OF DEFENCE',
	                footerBottom: 'Online advertising, TV, cinema / Agency: Steam / Director: Daniel Dow',
	                template: 'one'
	            }, {
	                background: 'background-7.jpg',
	                videoUrl: '219381520',
	                footerTop: 'THE SWIMMER / MINISTRY OF DEFENCE',
	                footerBottom: 'Online advertising, lifehacks, cinema, TV / Agency: Steam - Maarten Kuipers / Director: Nanno Jiskoot',
	                template: 'two'
	            }, {
	                background: 'background-1.jpg',
	                videoUrl: '250605329',
	                footerTop: 'SKILLED FOR LIFE / MINISTRY OF DEFENCE',
	                footerBottom: 'Online advertising, cinema, TV / Agency: Steam / Director: Daniël Dow',
	                template: 'two'
	            }, {
	                background: 'background-8.jpg',
	                videoUrl: '210899221',
	                footerTop: 'DOMINO / MINISTRY OF DEFENCE',
	                awards: 'true',
	                footerBottom: 'Online advertising, blogs, TV, cinema / Agency: Steam - Maarten Kuipers / Director: Bram van Alphen',
	                template: 'four'
	            }, {
	                background: 'background-6.jpg',
	                title: '',
	                subTitle: 'I work on many, many stories more',
	                underTitle: '',
	                clients: '<span>Advisery</span> Loyens & Loeff / McKinsey / NautaDutilh / Stibbe <span>Charity</span> Fonds verstandelijk gehandicapten / Greenpeace / Nationale Voorleesdagen (CPNB) / Vogelbescherming <span>Corporate & labour market</span> ABN AMRO / AVR / Arcadis / ASML / Belastingdienst / Bloemenveiling Aalsmeer / Canon / Ernst & Young / Essent / Flora Holland / FrieslandCampina / Heineken / KLM / KPN / Ministerie van Defensie / Nuon / NS / Rabobank / Signaal/Thales / Stork / PostNL <span>Cosmetics & body care</span> Acuvue / Nivea / Pearle / Weight Watchers <span>Drinks</span> Grolsch / Heineken / Coke light / Coolbest <span>Fashion</span> Nike / WE <span>Financials</span> AXA / Bouwfonds Hypotheken / Delta Lloyd / Ernst & Young / Huis & Hypotheek / ING / Interpay / Kempen & Co / Maestro / Menzis / Ohra / Optimix / Rabobank / Robeco / Trias / SNS Reaal / Triodos Bank / Van Lanschot Bankiers <span>Food</span> Beemsterkaas / Becel / Blue band / Calvé / Cup-a-soup / De Betuwe / Van Dobben / Festini / HAK / Hero Jam / Koopmans / Lätta / Maaslander / Magnum / Melitta / Unox <span>Government</span> Belastingdienst / De Nederlandsche Bank / Het Rijk / Ministeries van Binnenlandse Zaken / Defensie / Economische Zaken en VWS / Provincie Overijssel / UWV / BBIE <span>Hifi & TV</span> Bose / Sony / UPC <span>Household</span> Brabantia / Bosch / Celtona / Curver / Forbo / Lotus / Tefal / Vaillant <span>ICT & telecommunication</span> ASML / Atos Origin / CapGemini / Compaq / EDS / IBM / KPN / LogicaCMG / Microsoft / Telfort / Vodafone <span>Media</span> Intermediair / Kluwer / Noordhoff / RTL4 / Sanoma / STER <span>Pharmaceutical & health</span> AMC / Centocor / Davitamon / Maastricht UMC / MC Haaglanden / Ministerie van VWS en Inspectie Gezondheidszorg / Predictor / UMC Groningen / UMC Utrecht / VU Medisch Centrum <span>Retail</span> Albert / Albert Heijn / DA / De Broodzaak / Etos / Hema / KPN / Multimate / Nivea / Staatsloterij / Speurders.nl / Zeeman <span>Transport & logistics</span> Connexxion / DHL / NS / Van Oord Marine Engineering / ProRail / Shell / TLN / TNT Post <span>Travel & recreation</span> Aruba / Dolfinarium / D-Reizen / Happyhome / Holland Casino / Naturalis / Openluchtmuseum / Nederlands Bureau voor Toerisme / NEMO',
	                teaser: "Ask me about it or tell me your story: +316 5510 6320",
	                underTeaser: '',
	                template: 'five'
	            }],
	            count: 0,
	            oldCount: 0,
	            moving: false,
	            overlayOpen: false
	        };
	    },
	    mounted: function mounted() {
	        var isFirefox = typeof InstallTrigger !== 'undefined';
	        var isIE = false || !!document.documentMode;
	
	        if (isFirefox) {
	            window.addEventListener('DOMMouseScroll', this.moveSlider);
	        } else if (isIE) {
	            window.addEventListener('mousewheel', this.moveSlider);
	        } else {
	            window.addEventListener('wheel', this.moveSlider);
	        }
	
	        var _this = this;
	
	        setTimeout(function () {
	            _this.animateIn();
	        }, 600);
	    },
	
	    methods: {
	        moveSlider: function moveSlider(e) {
	            console.log('isIE2');
	
	            e.preventDefault();
	
	            var delta = e.wheelDelta ? e.wheelDelta : -e.detail;
	            var wDelta = delta < 0 ? 'down' : 'up';
	            var maxScroll = this.$refs.block.length - 2;
	            var header = document.querySelector('.header-block');
	
	            if (this.moving === false && this.overlayOpen === false) {
	                this.moving = true;
	                this.oldCount = this.count;
	
	                if (wDelta === 'down') {
	                    if (this.count <= maxScroll) {
	                        this.count++;
	                        this.movingAnimations();
	                    } else {
	                        this.moving = false;
	                    }
	                } else {
	                    if (this.count > 0) {
	                        this.count--;
	                        this.movingAnimations();
	                    } else {
	                        this.moving = false;
	                    }
	                }
	            }
	        },
	
	        movingAnimations: function movingAnimations() {
	            var tl = new _gsap.TimelineLite();
	            var easeAnim = _gsap.Power2.easeOut;
	            var contentBlocks = document.querySelectorAll('.content-block');
	            var currentBlock = contentBlocks[this.oldCount];
	            var playButton = currentBlock.querySelector('.content-block--play');
	            var title = currentBlock.querySelector('.title');
	            var subTitle = currentBlock.querySelector('.subtitle');
	            var underTitle = currentBlock.querySelector('.under-title');
	            var clientLine = currentBlock.querySelector('.content-block--client');
	            var creditsLine = currentBlock.querySelector('.content-block--credits');
	            var clientsLine = currentBlock.querySelector('.content-block--clients');
	            var slider = currentBlock.querySelector('.content-block--slider');
	            var teaser = currentBlock.querySelector('.teaser');
	            var awards = currentBlock.querySelector('.content-block--awards');
	            var underTeaser = currentBlock.querySelector('.under-teaser');
	
	            var newBlock = contentBlocks[this.count];
	            var newPlayButton = newBlock.querySelector('.content-block--play');
	            var newTitle = newBlock.querySelector('.title');
	            var newSubTitle = newBlock.querySelector('.subtitle');
	            var newUnderTitle = newBlock.querySelector('.under-title');
	            var newClientLine = newBlock.querySelector('.content-block--client');
	            var newCreditsLine = newBlock.querySelector('.content-block--credits');
	            var newClientsLine = newBlock.querySelector('.content-block--clients');
	            var newSlider = newBlock.querySelector('.content-block--slider');
	            var newTeaser = newBlock.querySelector('.teaser');
	            var newAwards = newBlock.querySelector('.content-block--awards');
	            var newUnderTeaser = newBlock.querySelector('.under-teaser');
	
	            tl.addLabel('startPoint');
	
	            if (playButton) {
	                tl.to(playButton, .3, {
	                    autoAlpha: 0,
	                    ease: easeAnim
	                }, 'startPoint');
	            }
	
	            if (clientsLine) {
	                tl.to(clientsLine, .3, {
	                    autoAlpha: 0,
	                    ease: easeAnim
	                }, 'startPoint');
	            }
	
	            if (slider) {
	                tl.to(slider, .3, {
	                    autoAlpha: 0,
	                    ease: easeAnim
	                }, 'startPoint');
	            }
	
	            if (awards) {
	                tl.to(awards, .3, {
	                    autoAlpha: 0,
	                    ease: easeAnim
	                }, 'startPoint');
	            }
	
	            if (title) {
	                tl.to(title, .3, {
	                    opacity: 0,
	                    y: -30,
	                    ease: easeAnim
	                }, 'startPoint');
	            }
	
	            if (subTitle) {
	                tl.to(subTitle, .3, {
	                    opacity: 0,
	                    y: -30,
	                    ease: easeAnim,
	                    delay: .1
	                }, 'startPoint');
	            }
	
	            if (underTitle) {
	                tl.to(underTitle, .3, {
	                    opacity: 0,
	                    y: -30,
	                    ease: easeAnim,
	                    delay: .1
	                }, 'startPoint');
	            }
	
	            if (clientLine) {
	                tl.to(clientLine, .3, {
	                    opacity: 0,
	                    y: 30,
	                    ease: easeAnim,
	                    delay: .2
	                }, 'startPoint');
	            }
	
	            if (teaser) {
	                tl.to(teaser, .3, {
	                    opacity: 0,
	                    y: 30,
	                    ease: easeAnim,
	                    delay: .2
	                }, 'startPoint');
	            }
	
	            if (creditsLine) {
	                tl.to(creditsLine, .3, {
	                    opacity: 0,
	                    y: 30,
	                    ease: easeAnim
	                }, 'startPoint');
	            }
	
	            if (underTeaser) {
	                tl.to(underTeaser, .3, {
	                    opacity: 0,
	                    y: 30,
	                    ease: easeAnim
	                }, 'startPoint');
	            }
	
	            tl.to(this.$refs.slider, .8, {
	                ease: _gsap.Power2.easeInOut,
	                top: '-' + 100 * this.count + '%',
	                onComplete: this.setMoving
	            });
	
	            tl.addLabel('secondPoint');
	
	            if (this.count === contentBlocks.length - 1) {
	                if (newClientsLine) {
	                    tl.to(newClientsLine, .3, {
	                        autoAlpha: 1,
	                        ease: easeAnim,
	                        delay: .3
	                    }, 'secondPoint');
	                }
	
	                if (newTitle) {
	                    tl.to(newTitle, .3, {
	                        opacity: 1,
	                        y: 0,
	                        ease: easeAnim
	                    }, 'secondPoint');
	                }
	
	                if (newSubTitle) {
	                    tl.to(newSubTitle, .3, {
	                        opacity: 1,
	                        y: 0,
	                        ease: easeAnim,
	                        delay: .1
	                    }, 'secondPoint');
	                }
	
	                if (newUnderTitle) {
	                    tl.to(newUnderTitle, .3, {
	                        opacity: 1,
	                        y: 0,
	                        ease: easeAnim,
	                        delay: .1
	                    }, 'secondPoint');
	                }
	
	                if (newTeaser) {
	                    tl.to(newTeaser, .3, {
	                        opacity: 1,
	                        y: 0,
	                        ease: easeAnim,
	                        delay: .9
	                    }, 'secondPoint');
	                }
	
	                if (newUnderTeaser) {
	                    tl.to(newUnderTeaser, .3, {
	                        opacity: 1,
	                        y: 0,
	                        ease: easeAnim,
	                        delay: 1
	                    }, 'secondPoint');
	                }
	            } else {
	                if (newPlayButton) {
	                    tl.to(newPlayButton, .3, {
	                        autoAlpha: 1,
	                        ease: easeAnim
	                    }, 'secondPoint');
	                }
	
	                if (newClientsLine) {
	                    tl.to(newClientsLine, .3, {
	                        autoAlpha: 1,
	                        ease: easeAnim
	                    }, 'secondPoint');
	                }
	
	                if (newSlider) {
	                    tl.to(newSlider, .3, {
	                        autoAlpha: 1,
	                        ease: easeAnim
	                    }, 'secondPoint');
	                }
	
	                if (newAwards) {
	                    tl.to(newAwards, .3, {
	                        autoAlpha: 1,
	                        ease: easeAnim
	                    }, 'secondPoint');
	                }
	
	                if (newTitle) {
	                    tl.to(newTitle, .3, {
	                        opacity: 1,
	                        y: 0,
	                        ease: easeAnim,
	                        delay: .1
	                    }, 'secondPoint');
	                }
	
	                if (newSubTitle) {
	                    tl.to(newSubTitle, .3, {
	                        opacity: 1,
	                        y: 0,
	                        ease: easeAnim
	                    }, 'secondPoint');
	                }
	
	                if (newUnderTitle) {
	                    tl.to(newUnderTitle, .3, {
	                        opacity: 1,
	                        y: 0,
	                        ease: easeAnim
	                    }, 'secondPoint');
	                }
	
	                if (newClientLine) {
	                    tl.to(newClientLine, .3, {
	                        opacity: 1,
	                        y: 0,
	                        ease: easeAnim
	                    }, 'secondPoint');
	                }
	
	                if (newTeaser) {
	                    tl.to(newTeaser, .3, {
	                        opacity: 1,
	                        y: 0,
	                        ease: easeAnim
	                    }, 'secondPoint');
	                }
	
	                if (newCreditsLine) {
	                    tl.to(newCreditsLine, .3, {
	                        opacity: 1,
	                        y: 0,
	                        ease: easeAnim,
	                        delay: .1
	                    }, 'secondPoint');
	                }
	
	                if (newUnderTeaser) {
	                    tl.to(newUnderTeaser, .3, {
	                        opacity: 1,
	                        y: 0,
	                        ease: easeAnim,
	                        delay: .1
	                    }, 'secondPoint');
	                }
	            }
	        },
	
	        setMoving: function setMoving() {
	            var _this = this;
	
	            setTimeout(function () {
	                _this.moving = false;
	            }, 500);
	        },
	
	        animateIn: function animateIn() {
	            var firstBlock = document.querySelector('.content-block--one');
	            var playButton = document.querySelector('.content-block--play');
	            var title = firstBlock.querySelector('h2');
	            var subTitle = firstBlock.querySelector('h3');
	            var clientLine = firstBlock.querySelector('.content-block--client');
	            var creditsLine = firstBlock.querySelector('.content-block--credits');
	            var header = document.querySelector('.header-block');
	            var easeAnim = _gsap.Power2.easeOut;
	            var tl = new _gsap.TimelineLite();
	
	            tl.to(firstBlock, .5, {
	                opacity: 1,
	                ease: easeAnim
	            });
	
	            tl.addLabel('startPoint');
	
	            tl.to(header, .7, {
	                y: 0,
	                ease: easeAnim
	            }, 'startPoint');
	
	            tl.addLabel('secondPoint');
	
	            tl.to(playButton, .5, {
	                autoAlpha: 1,
	                ease: easeAnim
	            }, 'secondPoint');
	
	            tl.to(title, .7, {
	                opacity: 1,
	                y: 0,
	                ease: easeAnim
	            }, 'secondPoint');
	
	            tl.to(subTitle, .7, {
	                opacity: 1,
	                y: 0,
	                ease: easeAnim,
	                delay: .2
	            }, 'secondPoint');
	
	            tl.to(clientLine, .7, {
	                opacity: 1,
	                y: 0,
	                ease: easeAnim
	            }, 'startPoint');
	
	            tl.to(creditsLine, .7, {
	                opacity: 1,
	                y: 0,
	                ease: easeAnim,
	                delay: .2
	            }, 'startPoint');
	        },
	
	        toggleOverlay: function toggleOverlay() {
	            var headerBlock = document.querySelector('.header-block');
	            var easeAnim = _gsap.Power2.easeOut;
	            var tl = new _gsap.TimelineLite();
	
	            if (this.overlayOpen === false) {
	                TweenMax.to(headerBlock, 1, {
	                    y: -100,
	                    ease: easeAnim
	                });
	
	                tl.to(this.$refs.contactOverlay, .3, {
	                    opacity: 1,
	                    className: "+=active",
	                    ease: easeAnim
	                });
	
	                this.overlayOpen = true;
	            } else {
	                TweenMax.to(headerBlock, 1, {
	                    y: 0,
	                    ease: easeAnim
	                });
	
	                tl.to(this.$refs.contactOverlay, .3, {
	                    opacity: 0,
	                    ease: easeAnim
	                });
	
	                tl.to(this.$refs.contactOverlay, .1, {
	                    className: "-=active",
	                    ease: easeAnim
	                });
	
	                this.overlayOpen = false;
	            }
	        }
	    }
	};

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _gsap = __webpack_require__(2);
	
	var _player = __webpack_require__(3);
	
	var _player2 = _interopRequireDefault(_player);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'ContentBlock',
	    props: ['item'],
	    data: function data() {
	        return {
	            templateClass: 'content-block--' + this.item.template,
	            moving: false,
	            count: 1,
	            endValue: 0,
	            moveValue: 0,
	            videoOpen: false
	        };
	    },
	    mounted: function mounted() {
	        this.$refs.contentBackground.style.backgroundImage = "url(" + 'static/images/' + this.item.background + ")";
	
	        if (this.$refs.slider) {
	            this.initSlider();
	            this.autoSlide();
	        }
	    },
	
	    methods: {
	        toggleVideo: function toggleVideo() {
	            var headerBlock = document.querySelector('.header-block');
	            var easeAnim = _gsap.Power2.easeOut;
	            var tl = new _gsap.TimelineLite();
	
	            if (this.videoOpen === false) {
	                this.$parent.videoOpen = true;
	                this.videoOpen = true;
	
	                this.toggleVimeo();
	
	                TweenMax.to(this.$refs.contentBackground, 1.2, {
	                    scale: 1.1,
	                    ease: easeAnim,
	                    delay: .5
	                });
	
	                TweenMax.to(headerBlock, 1, {
	                    top: -100,
	                    ease: easeAnim
	                });
	
	                tl.to(this.$refs.videoBlock, 1, {
	                    opacity: 1,
	                    className: "+=active",
	                    ease: easeAnim
	                }, '-=1');
	
	                tl.to(this.$refs.playCircle, .1, {
	                    width: 400,
	                    height: 400,
	                    ease: easeAnim
	                }, '-=1');
	
	                tl.to(this.$refs.playButton, .5, {
	                    opacity: 0,
	                    ease: easeAnim
	                }, '-=1.3');
	
	                tl.to(this.$refs.videoWrapper, .3, {
	                    opacity: 1,
	                    ease: easeAnim
	                });
	            } else {
	                this.$parent.videoOpen = false;
	                this.videoOpen = false;
	
	                tl.to(this.$refs.videoWrapper, .3, {
	                    opacity: 0,
	                    ease: easeAnim,
	                    onComplete: this.toggleVimeo
	                });
	
	                tl.to(this.$refs.videoBlock, 1, {
	                    opacity: 0,
	                    ease: easeAnim
	                }, '-=.3');
	
	                tl.to(this.$refs.videoBlock, .1, {
	                    className: "-=active",
	                    ease: easeAnim
	                });
	
	                tl.to(this.$refs.playButton, .5, {
	                    opacity: 1,
	                    ease: easeAnim
	                }, '-=1.1');
	
	                tl.to(this.$refs.playCircle, .1, {
	                    width: 110,
	                    height: 110,
	                    ease: easeAnim
	                }, '-=.9');
	
	                TweenMax.to(this.$refs.contentBackground, 1.2, {
	                    scale: 1,
	                    x: -50 + '%',
	                    y: -50 + '%',
	                    ease: easeAnim,
	                    delay: .5
	                });
	
	                TweenMax.to(headerBlock, 1, {
	                    top: 0,
	                    ease: easeAnim
	                });
	            }
	        },
	
	        toggleVimeo: function toggleVimeo() {
	            var player = new _player2.default(this.$refs.videoWrapper, {
	                id: this.item.videoUrl,
	                width: 640
	            });
	
	            var mq = window.matchMedia("(max-width: 1023px)");
	            if (!mq.matches) {
	                if (this.videoOpen === true) {
	                    player.play();
	                } else {
	                    player.pause();
	                }
	            }
	        },
	
	        initSlider: function initSlider() {
	            var slider = document.querySelector('.content-block--slider--wrapper');
	            var allSlides = slider.querySelectorAll('li');
	            var slidesAmount = allSlides.length;
	            var firstSlide = allSlides[0];
	            var lastSlide = allSlides[slidesAmount - 1];
	            this.endValue = allSlides.length;
	
	            var cloneFirstSlide = firstSlide.cloneNode(true);
	            var cloneLastSlide = lastSlide.cloneNode(true);
	
	            slider.appendChild(cloneFirstSlide);
	            slider.insertBefore(cloneLastSlide, slider.childNodes[0]);
	
	            var totalItems = slidesAmount + 2;
	            var sliderWidth = totalItems * 100 + '%';
	            var itemWidth = 100 / totalItems + '%';
	
	            slider.style.left = -100 + '%';
	            slider.style.width = sliderWidth;
	
	            allSlides = slider.querySelectorAll('li');
	
	            for (var i = 0; i < allSlides.length; i++) {
	                allSlides[i].style.width = itemWidth;
	            }
	        },
	
	        slideLeft: function slideLeft() {
	            if (this.moving === false) {
	                this.count--;
	                this.animateSlider();
	            }
	        },
	
	        slideRight: function slideRight() {
	            if (this.moving === false) {
	                this.count++;
	                this.animateSlider();
	            }
	        },
	
	        autoSlide: function autoSlide() {
	            var _this = this;
	
	            timeout();
	
	            function timeout() {
	                setTimeout(function () {
	                    _this.slideRight();
	                    timeout();
	                }, 5000);
	            }
	        },
	
	        animateSlider: function animateSlider() {
	            var slider = document.querySelector('.content-block--slider--wrapper');
	            this.moving = true;
	            this.moveValue = this.count * -100 + '%';
	            var sliderStartValue = this.endValue * -100 + '%';
	            var tl = new _gsap.TimelineLite();
	
	            if (this.count === 0) {
	                this.count = this.endValue;
	                this.moveLeft(tl);
	                tl.to(slider, 0, { left: sliderStartValue });
	            } else if (this.count > this.endValue) {
	                this.count = 1;
	                this.moveLeft(tl);
	                tl.to(slider, 0, { left: -100 + '%' });
	            } else {
	                this.moveLeft(tl);
	            }
	        },
	
	        moveLeft: function moveLeft(tl) {
	            var slider = document.querySelector('.content-block--slider--wrapper');
	            tl.to(slider, .8, { left: this.moveValue, onComplete: this.doneMoving });
	        },
	
	        doneMoving: function doneMoving() {
	            this.moving = false;
	        },
	
	        moveDown: function moveDown(e) {
	            this.$parent.moveSlider(e);
	        }
	    }
	};

/***/ },
/* 6 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'HeaderBlock',
	    mounted: function mounted() {},
	
	    methods: {
	        toggleOverlay: function toggleOverlay() {
	            this.$parent.toggleOverlay();
	        }
	    }
	};

/***/ },
/* 7 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(7)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(4),
	  /* template */
	  __webpack_require__(15),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(5),
	  /* template */
	  __webpack_require__(14),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(6),
	  /* template */
	  __webpack_require__(16),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 14 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-block",
	    class: _vm.templateClass
	  }, [_c('div', {
	    ref: "contentBackground",
	    staticClass: "content-block--background"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "content-block--content"
	  }, [_c('div', {
	    staticClass: "content-block--title"
	  }, [(this.item.title != undefined) ? _c('h2', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(this.item.title))]) : _vm._e(), _vm._v(" "), (this.item.subTitle != undefined) ? _c('h3', {
	    staticClass: "subtitle"
	  }, [_vm._v(_vm._s(this.item.subTitle))]) : _vm._e(), _vm._v(" "), (this.item.underTitle != undefined) ? _c('h4', {
	    staticClass: "under-title"
	  }, [_vm._v(_vm._s(this.item.underTitle))]) : _vm._e()]), _vm._v(" "), (this.item.videoUrl != undefined) ? _c('div', {
	    ref: "playButton",
	    staticClass: "content-block--play",
	    on: {
	      "click": _vm.toggleVideo
	    }
	  }, [_c('div', {
	    ref: "playCircle",
	    staticClass: "content-block--play--circle"
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": "static/images/play.png",
	      "alt": "play button"
	    }
	  })]) : _vm._e(), _vm._v(" "), (this.item.slider != undefined) ? _c('div', {
	    ref: "slider",
	    staticClass: "content-block--slider"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "content-block--slider--next",
	    on: {
	      "click": _vm.slideRight
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "content-block--slider--prev",
	    on: {
	      "click": _vm.slideLeft
	    }
	  })]) : _vm._e(), _vm._v(" "), (this.item.awards != undefined) ? _c('div', {
	    staticClass: "content-block--awards"
	  }, [_vm._m(1), _vm._v(" "), _vm._m(2)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "content-block--footer"
	  }, [(this.item.footerTop != undefined) ? _c('p', {
	    staticClass: "content-block--client"
	  }, [_vm._v("\n                " + _vm._s(this.item.footerTop) + "\n            ")]) : _vm._e(), _vm._v(" "), (this.item.footerBottom != undefined) ? _c('p', {
	    staticClass: "content-block--credits"
	  }, [_vm._v("\n                " + _vm._s(this.item.footerBottom) + "\n            ")]) : _vm._e()]), _vm._v(" "), (this.item.clients != undefined) ? _c('div', {
	    staticClass: "content-block--clients",
	    domProps: {
	      "innerHTML": _vm._s(this.item.clients)
	    }
	  }) : _vm._e(), _vm._v(" "), (this.item.teaser != undefined) ? _c('div', {
	    staticClass: "content-block--teaser"
	  }, [_c('h2', {
	    staticClass: "teaser"
	  }, [_vm._v(_vm._s(this.item.teaser))]), _vm._v(" "), _c('h3', {
	    staticClass: "under-teaser"
	  }, [_vm._v(_vm._s(this.item.underTeaser))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    ref: "videoBlock",
	    staticClass: "content-block--video",
	    on: {
	      "click": _vm.toggleVideo
	    }
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "content-block--video--container"
	  }, [_c('div', {
	    ref: "videoWrapper",
	    staticClass: "wrapper"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "content-block--more",
	    on: {
	      "click": _vm.moveDown
	    }
	  }, [_vm._v("\n            More work\n            "), _vm._m(4)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-block--slider--container"
	  }, [_c('ul', {
	    staticClass: "content-block--slider--wrapper"
	  }, [_c('li', {
	    staticClass: "content-block--slide"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/images/slide-1.jpg",
	      "alt": "slider image"
	    }
	  })]), _vm._v(" "), _c('li', {
	    staticClass: "content-block--slide"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/images/slide-2.jpg",
	      "alt": "slider image"
	    }
	  })]), _vm._v(" "), _c('li', {
	    staticClass: "content-block--slide"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/images/slide-3.jpg",
	      "alt": "slider image"
	    }
	  })]), _vm._v(" "), _c('li', {
	    staticClass: "content-block--slide"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/images/slide-4.jpg",
	      "alt": "slider image"
	    }
	  })])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-block--awards--left"
	  }, [_vm._v("\n                Recent awards for our work"), _c('br'), _vm._v("\n                with the Ministry of Defence\n            ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-block--awards--right"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/images/awards.png",
	      "srcset": "static/images/awards@2x.png 2x",
	      "alt": "awards"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-block--video--close"
	  }, [_c('span'), _vm._v(" "), _c('span')])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    attrs: {
	      "src": "static/images/arrow-down.png"
	    }
	  })])
	}]}

/***/ },
/* 15 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('header-block', {
	    ref: "header"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    ref: "slider",
	    staticClass: "slider"
	  }, [_vm._l((_vm.blocks), function(block) {
	    return [_c('content-block', {
	      ref: "block",
	      refInFor: true,
	      attrs: {
	        "item": block
	      }
	    })]
	  })], 2), _vm._v(" "), _c('div', {
	    ref: "contactOverlay",
	    staticClass: "contact-overlay"
	  }, [_c('div', {
	    staticClass: "content-block--video--close",
	    on: {
	      "click": _vm.toggleOverlay
	    }
	  }, [_c('span'), _vm._v(" "), _c('span')]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _vm._m(1)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "contact-overlay--container"
	  }, [_c('img', {
	    staticClass: "logo",
	    attrs: {
	      "src": "/static/images/logo.png",
	      "alt": "logo"
	    }
	  }), _vm._v(" "), _c('h3', [_vm._v("Call +31 6 55 10 63 20"), _c('br'), _vm._v("\n                    or "), _c('a', {
	    staticClass: "mail",
	    attrs: {
	      "href": "mailto:mail@johnhorjus.nl"
	    }
	  }, [_vm._v("mail@johnhorjus.nl")])]), _vm._v(" "), _c('a', {
	    staticClass: "linkedIn",
	    attrs: {
	      "href": "https://www.linkedin.com/in/johnhorjus/",
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/images/linkedin.png",
	      "alt": "linkedin"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "mobile-fallback"
	  }, [_c('div', {
	    staticClass: "mobile-fallback--inner"
	  }, [_c('img', {
	    attrs: {
	      "src": "static/images/rotate.png",
	      "alt": "rotate"
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("Please turn your device.")])])])
	}]}

/***/ },
/* 16 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "header-block"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "header-block--right"
	  }, [_c('a', {
	    on: {
	      "click": _vm.toggleOverlay
	    }
	  }, [_vm._v("\n            Contact\n        ")])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "header-block--left"
	  }, [_c('h1', {
	    staticClass: "header-block--title"
	  }, [_vm._v("\n            John Horjus\n        ")]), _vm._v(" "), _c('p', {
	    staticClass: "header-block--undertitle"
	  }, [_vm._v("\n            Freelance creative/director\n        ")])])
	}]}

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.c4c43919d16b9126371d.js